module.exports = __webpack_public_path__ + "img/analyser-done.84d115c3.svg";